/* p-defer/index */ function _(require, module, exports) {
    module.exports = () => {
        const ret = {};
        ret.promise = new Promise((resolve, reject) => {
            ret.resolve = resolve;
            ret.reject = reject;
        });
        return ret;
    };
}
